import React, { useEffect, useState } from 'react';
import { Container, Header, Table, NoneContent } from './styled';
import Editor from './Editor';
import Viewer from './Viewer';
import { NamedCommunityService } from 'services/named';
import { useHistory } from 'react-router-dom';

const Analysis = ({ gameId, sportsType }) => {
  const history = useHistory();
  const query = new URLSearchParams(history.location.search);
  const wrId = query.get('wrId') || '';

  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);

  const [data, setData] = useState(null);
  const [viewForm, setViewForm] = useState(false);

  useEffect(() => {
    getAnalysisList();
  }, []);

  useEffect(() => {
    if (wrId) {
      NamedCommunityService.detail(wrId, 'sports_analysis').then((res) => {
        if (res.code === 200) {
          setData(res.data);
        } else {
          alert(res.message);
          history.replace({
            search: ''
          });
        }
      });
    } else {
      setData(null);
    }
  }, [wrId]);

  const getDetail = async (wrId) => {
    NamedCommunityService.detail(wrId, 'sports_analysis').then((res) => {
      if (res.code === 200) {
        setData(res.data);
      } else {
        alert(res.message);
        history.replace({
          search: ''
        });
      }
    });
  };

  const getAnalysisList = async () => {
    await NamedCommunityService.list({
      board_type: 'sports_analysis',
      game_id: gameId
    }).then((res) => {
      if (res.code === 200) {
        setList(res.data.list);
      }
      setLoading(false);
    });
  };

  const getBaseSubject = (homeTeam, awayTeam) => {
    if (!!homeTeam && !!awayTeam) {
      return `[${homeTeam} vs ${awayTeam}] `;
    }
    return '';
  };

  return (
    <Container>
      {!!data && (
        <Viewer
          data={data}
          setData={setData}
          setViewForm={setViewForm}
          getDetail={getDetail}
        />
      )}
      <Editor
        data={data}
        setData={setData}
        gameId={gameId}
        view={viewForm}
        setView={setViewForm}
        getAnalysisList={getAnalysisList}
        isModify={!!wrId}
        sportsType={sportsType}
      />
      <Header>
        <p>경기 분석글</p>
        <button onClick={() => setViewForm(true)}>글쓰기</button>
      </Header>
      <Table>
        <colgroup>
          <col width={'60%'} />
          <col width={'20%'} />
          <col width={'10%'} />
          <col width={'10%'} />
        </colgroup>
        <thead>
          <tr>
            <th>제목</th>
            <th>작성자</th>
            <th>조회</th>
            <th>추천</th>
          </tr>
        </thead>
        <tbody>
          {list.map((item, key) => {
            const {
              wr_subject,
              wr_name,
              wr_hit,
              wr_good,
              home_team,
              away_team
            } = item;
            return (
              <tr
                key={key}
                onClick={() => {
                  history.replace({
                    search: `wrId=${item.wr_id}`
                  });
                }}
              >
                <td>
                  <p>{wr_subject}</p>
                </td>
                <td>{wr_name}</td>
                <td>{wr_hit}</td>
                <td>{wr_good}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      {list.length === 0 && !loading && (
        <NoneContent>
          <p>작성된 분석글이 없습니다.</p>
        </NoneContent>
      )}
    </Container>
  );
};

export default Analysis;
